"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PhoneNumberModel {
    constructor(label, phoneNumber) {
        this.label = label;
        this.iconName = this.label === 'Phone' ? 'briefcase' :
            this.label === 'Mobile Phone' ? 'phone-portrait' :
                this.label === 'Home Phone' ? 'home' :
                    this.label === 'Other Phone' ? 'call' : '';
        // support number as an existing PhoneNumberModel or as a string
        this.number = (phoneNumber instanceof Object) ? phoneNumber.number : phoneNumber;
    }
    get actionLink() {
        return (this.number) ? `tel://${this.number.replace(/\s+/g, '')}` : '';
    }
}
exports.PhoneNumberModel = PhoneNumberModel;
//# sourceMappingURL=phone-number.model.js.map